import http from '../_http_v2';

const report = {
  //default
  list: (m) => { return http.post(`console/wsfinder/report/list`, m); },
  detail: (m) => { return http.get(`console/wsfinder/report/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/wsfinder/report`, m); },
  update: (m) => { return http.put(`console/wsfinder/report`, m); },
  delete: (m) => { return http.delete(`console/wsfinder/report/${m.id}`); },

  //other
  new: (m) =>{ return http.post(`console/wsfinder/report/new`, m); },
}

export default report

export { report }